import React from 'react'

function Loading() {
    return (
        <div>
            <div className="text-center">
                <div className="spinner-border m-5" role="status">
                    <span className="visually-hidden">Loading...</span>
                </div>
            </div>
        </div>
    )
}
export default Loading;
